module.exports = __webpack_public_path__ + "static/media/fn2.ba91c813.svg";